import * as t from 'io-ts';

import {makeApiType, makeEnumRuntimeType} from './apiTypes';

/*
 * Runtime type.
 */

export enum CustomViewTypesEnum {
  TAG = 'tag',
  PRIVATE_TAG = 'private_tag',
}

export enum CustomViewBundleRolesEnum {
  INCREMENT_METADATA = 'increment_conversation_metadata',
  RESET_METADATA = 'reset_conversation_metadata',
  ADD_TO_CUSTOM_VIEW = 'add_conversation_to_custom_view',
  REMOVE_FROM_CUSTOM_VIEW = 'remove_conversation_from_custom_view',
}

const RCustomViewDirty = t.readonly(
  t.type({
    id: t.Integer,
    url: t.string,
    namespace: t.string,
    type: makeEnumRuntimeType(CustomViewTypesEnum),
    uid: t.union([t.string, t.undefined]),
  }),
  'customView',
);

const RCustomViews = t.readonlyArray(RCustomViewDirty);

/*
 * Type.
 */

export interface CustomViewModel extends t.TypeOf<typeof RCustomViewDirty> {}
export const RCustomView = t.clean<CustomViewModel>(RCustomViewDirty as any);

/*
 * IO methods.
 */

export function parseCustomView(src: any): CustomViewModel {
  return {
    // Custom views are currently just thin wrappers of tags and don't have concrete IDs.
    id: src.meta.tag_id,
    url: src.url,
    namespace: src.namespace,
    type: src.type,
    uid: src.uid,
  };
}

export function parseCustomViews(src: any): ReadonlyArray<CustomViewModel> {
  const customViews = src.custom_views;
  return customViews && customViews.map((c: any) => parseCustomView(c));
}

/*
 * API type.
 */

export const ApiCustomView = makeApiType('customView', RCustomView, parseCustomView);
export const ApiCustomViews = makeApiType('customViews', RCustomViews, parseCustomViews);
